import request from './request';

export const articleApi = {
  // 获取最新文章列表
  getLatestArticles() {
    return request({
      url: '/api/articles/latest',
      method: 'get'
    });
  },
  // 获取分类最新文章
  getCategoryLatestArticles(cids = [28, 35, 63], count = 4) {
    return request({
      url: '/api/articles/categories/latest',
      method: 'post',
      data: {
        cids,
        count
      }
    });
  },
  // 获取指定分类的文章（带分页）
  getArticlesByCategory(categoryId, pageIndex, pageSize) {
    return request({
      url: `/api/articles/category/${categoryId}`,
      method: 'get',
      params: {
        page_index: pageIndex,
        page_size: pageSize
      }
    });
  }
}; 